import styled from "styled-components";

export const List = styled.ul`
  flex-direction: column;
  padding: 5px;

  width: 100%;
`;

export const Item = styled.li`
  padding: 10px;
  border: 1px solid var(--panel);
  margin-bottom: 5px;

  align-items: center;

  cursor: pointer;

  width: 100%;

  border-radius: 4px;

  justify-content: space-between;

  :active {
    background-color: var(--panel);
  }

  > div {
    flex-direction: column;

    h5 {
      font-weight: bold;
    }
  }
`;

export const DataWrapper = styled.div`
  flex-direction: column;
  padding: 15px;
  margin-bottom: 5px;

  width: 100%;

  height: 400px;
`;
